import { render, staticRenderFns } from "./MonthsComponent.vue?vue&type=template&id=38108960&scoped=true&"
import script from "./MonthsComponent.vue?vue&type=script&lang=js&"
export * from "./MonthsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38108960",
  null
  
)

export default component.exports